<template>
  <div>
    <CalendarCanvas :fontFamily="fontFamily" :fontFamilyMonthYear="fontFamilyMonthYear" :fontFamilyWeek="fontFamilyWeek"
      :configsBodyRender="configsBodyRender" @change="handleFileRender" />
    <div :class="{ loading: loading }" class="group_date_picker_layer">
      <date-picker v-model="date" type="date" format="MM/DD/YYYY" title-format="DD/MM/YYYY"
        time-title-format="DD/MM/YYYY" valueType="DD/MM/YYYY" class="calendar-picker-layer" placeholder="MM/DD/YYYY"
        @change="renderImage"></date-picker>
      <div v-if="loading" class="group_date_picker_layer_loading">
        <font-awesome-icon icon="spinner" class="fa-spin" />
      </div>
    </div>
    <div class="group_date_picker_layer_mobile">
      <div class="group_date_picker_layer_mobile__btn" @click="handleOpenData">
        <div>
          {{ formatDate(date) }}
        </div>
        <div>
          <div v-if="loading" class="group_date_picker_layer_loading">
            <font-awesome-icon icon="spinner" class="fa-spin" />
          </div>
          <v-icon v-else style="width: 18px" name="calendar"></v-icon>
        </div>
      </div>
      <div v-if="openSelectDate" class="group_date_picker_layer_mobile__model">
        <date-picker v-model="dateMobile" type="date" title-format="DD/MM/YYYY" format="MM/DD/YYYY"
          time-title-format="DD/MM/YYYY" valueType="DD/MM/YYYY" class="calendar-picker-layer"
          popup-class="calendar-picker-layer-mobile" placeholder="MM/DD/YYYY" :open="true"></date-picker>
        <div class="calendar-picker-layer-footer-mobile">
          <button type="button" @click="hideDateMobile" class="btn Abn-btn-cancel">Cancel</button>
          <button type="button" class="btn Abn-btn-apply" @click="handleApplyDateMobile">Apply</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ASSET_URL } from '../../config'
import { mapGetters, mapMutations } from 'vuex'
import { get } from 'lodash'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import CalendarCanvas from '../Render/CalendarCanvas.vue'
export default {
  name: 'ImageCalendarPicker',
  components: {
    DatePicker,
    CalendarCanvas
  },
  data() {
    return {
      date: null,
      dateMobile: null,
      loading: false,
      openSelectDate: false,
      configsBodyRender: {}
    }
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    aspectRatio: {
      type: Number,
      default() {
        return 1
      }
    },
    configsCalendar: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      default() {
        return null
      }
    }
  },
  computed: {
    localStorageName() {
      return this.context.name + '_' + this.product().id
    },
    fontFamily() {
      const { configsCalendar } = this;
      return get(configsCalendar, 'fontFamily', "");
    },
    fontFamilyMonthYear() {
      const { configsCalendar } = this;
      return get(configsCalendar, 'fontFamilyMonthYear', "");
    },
    fontFamilyWeek() {
      const { configsCalendar } = this;
      return get(configsCalendar, 'fontFamilyWeek', "");
    }
  },
  watch: {
    context(v) {
      const { date } = v.model
      if (date) {
        this.date = date
      }
    }
  },
  created() {
    const { date } = this.configsCalendar;
    if (date) {
      this.date = date
    }
  },
  methods: {
    ...mapGetters(['product', 'platform', 'getCartData', 'isSaveLocalstorage']),
    ...mapMutations([
      'setCartDataByKey',
      'setMessageError',
      'setLoadingForm',
      'setIsSaveLocalstorage'
    ]),
    formatDate(date) {
      if (!date) {
        return "Select date";
      }
      const dayArray = date.split('/');
      const [day, month, year] = dayArray;
      return `${month}/${day}/${year}`;;
    },
    handleOpenData(v) {
      this.dateMobile = this.date;
      this.openSelectDate = true;
    },
    hideDateMobile() {
      this.openSelectDate = false;
    },
    handleApplyDateMobile() {
      const { dateMobile } = this;
      this.date = dateMobile;
      this.renderImage(dateMobile);
      this.openSelectDate = false;
    },
    async renderImage(date) {
      if (!date) return
      const { configsCalendar, localStorageName, context } = this
      this.loading = true;
      this.openSelectDate = false;
      const body = {
        ...configsCalendar,
        scale: 1.25,
        heartUrl:
          configsCalendar.heartUrl && configsCalendar.heartUrl.key
            ? ASSET_URL + '/' + configsCalendar.heartUrl.key
            : null,
        date
      }
      this.configsBodyRender = { ...body };
    },
    handleFileRender(datas) {
      const { localStorageName, context } = this;
      const { base64, configs, date } = datas;

      const file = {
        id: this.context.name,
        base64,
        date
      }
      this.context.model = file;

      this.setIsSaveLocalstorage(true);
      this.setCartDataByKey({
        key: localStorageName,
        name: context.label,
        value: {
          configsCalendar: { ...configs }
        }
      });
      this.loading = false;
    }
  }
}
</script>

<style>
.mx-calendar * {
  font-family: system-ui;
  font-size: 14px;
}

.calendar-picker-layer {
  width: 100%;
}

.calendar-picker-layer input.mx-input {
  height: 40px;
  font-size: 16px;
  color: #555;
  font-weight: 500;
  font-family: system-ui;
  margin: 0 !important;
  border-radius: 3px;
  outline: none;
  box-shadow: none;
}

tr.mx-date-row td {
  border: none !important;
}

tr.mx-date-row td div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.mx-calendar-content .cell.active {
  color: #fff;
  background-color: #686b5a;
  border-radius: 5px;
  font-weight: 800;
}

.mx-table thead tr th {
  font-weight: 700;
  text-align: center;
  border: none !important;
}

.group_date_picker_layer {
  position: relative;
}

.group_date_picker_layer_loading {
  position: absolute;
  top: 0;
  background: #0000001c;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px;
  border-radius: 5px;
  cursor: not-allowed;
}

.group_date_picker_layer.loading i.mx-icon-calendar {
  display: none;
}

table.mx-table.mx-table-year tr td,
table.mx-table.mx-table-month tr td {
  text-align: center;
  border: none !important;
}

.group_date_picker_layer_mobile {
  display: none;
}

@media (max-width:641px) {
  .group_date_picker_layer {
    display: none !important;
  }

  .group_date_picker_layer_mobile {
    display: block;
  }

  .group_date_picker_layer_mobile__btn {
    height: 40px;
    font-size: 16px;
    color: #555;
    font-weight: 500;
    font-family: system-ui;
    margin: 0 !important;
    border-radius: 3px;
    outline: none;
    border: 1px solid #ccc;
    display: flex;
    padding: 10px;
    align-items: center;
    box-shadow: none !important;
    line-height: 0 !important;
    background: #fff;
    position: relative;
    justify-content: space-between;
    margin: 0px !important;
  }

  .group_date_picker_layer_mobile__model {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    padding: 10px;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .calendar-picker-layer-mobile {
    position: absolute;
    left: 10px !important;
    right: 10px !important;
    box-shadow: none !important;
    border: none;
  }

  .calendar-picker-layer-mobile .mx-calendar.mx-calendar-panel-date,
  .calendar-picker-layer-mobile .mx-calendar {
    width: 100% !important;
  }

  button.btn.Abn-btn-cancel {
    background: #7b7b7e !important;
    color: white !important;
    font-weight: 600 !important;
    width: 49%;
    float: left;
    font-weight: 700 !important;
  }

  button.btn.Abn-btn-apply {
    background: none 0% 0% / auto repeat scroll padding-box border-box rgb(33 171 43) !important;
    color: white !important;
    font-weight: 600 !important;
    width: 49%;
    float: left;
    font-weight: 700 !important;
  }

  .calendar-picker-layer-footer-mobile {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .group_date_picker_layer_mobile__model .calendar-picker-layer.mx-datepicker .mx-input-wrapper {
    display: none;
  }

  .calendar-picker-layer-footer-mobile button {
    margin: 0 !important;
    border-radius: 3px;
    font-family: system-ui;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Formulate/ImageCalendarPicker.vue